import { PlaceholderEnum } from '../../placeholders-panel';

let _fixedKeys: ReadonlySet<string> | null = null;
function getFixedKeys(): ReadonlySet<string> {
  if (_fixedKeys === null) _fixedKeys = new Set(Object.values(PlaceholderEnum));
  return _fixedKeys;
}

export const VALID_CUSTOM_KEY_REGEX = /^[a-z][a-z0-9_]{1,49}$/;

export const VARIABLE_KEY_PATTERN_SOURCE = '[a-z][a-z0-9_]{1,49}';

export function isCustomVariable(key: string): boolean {
  if (!key) return false;
  return !getFixedKeys().has(key.toLowerCase());
}

export function isValidCustomKey(key: string): boolean {
  return VALID_CUSTOM_KEY_REGEX.test(key);
}

export function normalizeCustomKey(input: string): string {
  return (input ?? '')
    .trim()
    .replace(/^\{+|\}+$/g, '')
    .trim()
    .toLowerCase();
}

export function humanizarChave(chave: string): string {
  return chave
    .replace(/^\{+|\}+$/g, '')
    .split('_')
    .filter(Boolean)
    .map(p => p.charAt(0).toUpperCase() + p.slice(1))
    .join(' ');
}

export function isFixedKey(key: string): boolean {
  return getFixedKeys().has(key.toLowerCase());
}

export function extractCustomKeysFromContent(content: string | undefined): string[] {
  if (!content) return [];
  const seen = new Set<string>();
  const patterns = [
    new RegExp(`\\{(${VARIABLE_KEY_PATTERN_SOURCE})\\}`, 'g'),
    new RegExp(`data-variable="(${VARIABLE_KEY_PATTERN_SOURCE})"`, 'g'),
  ];
  for (const pattern of patterns) {
    let m: RegExpExecArray | null;
    while ((m = pattern.exec(content)) !== null) {
      const key = m[1].toLowerCase();
      if (!getFixedKeys().has(key)) seen.add(key);
    }
  }
  return Array.from(seen).sort();
}

export function countVariableUsage(content: string | undefined): Map<string, number> {
  const counts = new Map<string, number>();
  if (!content) return counts;
  const pattern = new RegExp(`\\{(${VARIABLE_KEY_PATTERN_SOURCE})\\}`, 'gi');
  let m: RegExpExecArray | null;
  while ((m = pattern.exec(content)) !== null) {
    const key = m[1].toLowerCase();
    counts.set(key, (counts.get(key) ?? 0) + 1);
  }
  return counts;
}
